const MONTHS = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru']

export default {
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      const d = new Date(dateString)
      const day = d.getDate()
      const month = MONTHS[d.getMonth()]
      const year = d.getFullYear()
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${day} ${month} ${year} ${hours}:${minutes}`
    },
    formatDateShort(dateString) {
      if (!dateString) return ''
      const d = new Date(dateString)
      const day = d.getDate()
      const month = MONTHS[d.getMonth()]
      const year = d.getFullYear()
      return `${day} ${month} ${year}`
    },
    formatTime(dateString) {
      if (!dateString) return ''
      const d = new Date(dateString)
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    isSameDay(dateString1, dateString2) {
      if (!dateString1 || !dateString2) return false
      const d1 = new Date(dateString1)
      const d2 = new Date(dateString2)
      return d1.getFullYear() === d2.getFullYear()
        && d1.getMonth() === d2.getMonth()
        && d1.getDate() === d2.getDate()
    },
  },
}
